import axios from 'axios';
const state = {};
import config from '@/../config';
const defaultErrorHandler = error => Promise.reject(error.response);

const mutations = {};

const actions = {
  async INSERT_TAKER({ commit }, payload) {
    delete payload.stepType;
    let response = await axios.post(
      config.apiUrl + config.versoes[0] + '/tomador',
      payload
    );
    return response.data;
  },

  async GET_TAKERS({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl + config.versoes[0] + '/tomador-corretor'
    );

    return response.data;
  },

  async NEW_GET_TAKERS({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl + config.versoes[0] + '/tomador-corretor-listar/'
    );

    return response.data;
  },

  async GET_TAKERS_FILTERS({ commit }, payload) {
    const url = `${config.apiUrl}${config.versoes[0]}/tomador-corretor-listar/`;

    let response = await axios.get(url, { params: payload });

    return response.data;
  },

  async GET_GRUPO_ECONOMICO({ commit }, payload) {
    let response = await axios.get(
      `${config.apiUrl}${config.versoes[0]}/tomador-corretor-listar/${payload.cnpj_cpf}/grupo-economico`
    ).then(res => {return res.data});
    
    return response;
  },


  async GET_GRUPO_ECONOMICO({ commit }, payload) {
    let response = await axios.get(
      `${config.apiUrl}${config.versoes[0]}/tomador-corretor-listar/${payload.cnpj_cpf}/grupo-economico`
    ).then(res => {return res.data});
    
    return response;
  },

  async GET_TAKER_BY_CNPJ({ commit }, payload) {
    // return {"id": 3643, "id_tomador": 1293, "cnpj_cpf": "03022656000101", "nome": "PROFILATICA PRODUTOS ODONTO MEDICO HOSPITALARES LTDA", "endereco": {"cidade": "Araucaria", "bairro": "Barigui", "cep": "83707690", "uf": "PR", "logradouro": "R Jose Cheinfert, 315"}, "status_nomeado": "CORRETOR_NOMEADO", "tipo_pessoa": "JURIDICA", "telefone": "4133457500", "email": "alexandre@profilatica.com.br", "ativo": true, "participantes_consorcio": [{"documento": "521295609970", "id_participante": 1294, "porcentagem": 100.0, "nome": "Virginia Polinari De Araujo"}, {"documento": "521295609970", "id_participante": 1294, "porcentagem": 100.0, "nome": "Virginia Polinari De Araujo"}, {"documento": "521295609970", "id_participante": 1294, "porcentagem": 100.0, "nome": "Virginia Polinari De Araujo"}], "grupo_economico": [{"documento": "521295609970", "id_participante": 1294, "porcentagem": 100.0, "nome": "Virginia Polinari De Araujo"}], "situacao_ativo": true, "documentos": [], "acompanhamento": [], "sublimites": [{"segurado": "P\u00fablico", "limite_credito": 500000.0, "modalidade": "Licitante / Judicial-Recursal", "limite_tomado": 0.0, "limite_disponivel": 500000.0}, {"segurado": "P\u00fablico", "limite_credito": 500000.0, "modalidade": "Tradicionais", "limite_tomado": -50000.0, "limite_disponivel": 450000.0}, {"segurado": "Privado", "limite_credito": 500000.0, "modalidade": "Imobili\u00e1rio", "limite_tomado": 0.0, "limite_disponivel": 500000.0}, {"segurado": "P\u00fablico", "limite_credito": 500000.0, "modalidade": "Concess\u00e3o/ANEEL", "limite_tomado": 0.0, "limite_disponivel": 500000.0}, {"segurado": "Privado", "limite_credito": 500000.0, "modalidade": "Tradicionais", "limite_tomado": 0.0, "limite_disponivel": 500000.0}, {"segurado": "Privado", "limite_credito": 500000.0, "modalidade": "Licitante", "limite_tomado": 0.0, "limite_disponivel": 500000.0}], "limite_aprovado": 3000000.0, "limite_tomado": -50000.0, "limite_disponivel": 2950000.0}
    let response;
    response = await axios.get(
      config.apiUrl +
      config.versoes[0] +
      `/tomador-corretor/${payload.takerCNPJ}`
    );

    return response.data;
  },

  async GET_TAKER_LIMITS_BY_CNPJ({ commit }, payload) {
    // return {"nome":"Autofacil Consultoria E Corretagem De Seguros Ltda","cnpj_cpf":"21684275000161","ativo":true,"status_nomeado":"SEM_NOMEACAO","telefone":"2131746669","tipo_pessoa":"JURIDICA","endereco":{"logradouro":"Avenida Alfredo Balthazar Da Silveira, 580 - Sala 214 A","uf":"RJ","cidade":"RIO DE JANEIRO","cep":"22790710","bairro":"RECREIO DOS BANDEIRANTES"},"email":"","id":2205}
    let response = await axios.get(
      config.apiUrl +
      config.versoes[0] +
      `/tomador-corretor/${payload.takerCNPJ}/limites-taxas`
    );

    return response.data;
  },

  async GET_TAKER_DATA({ commit }, payload) {
    // return [{"endereco": {"bairro": "AGUA VERDE", "cidade": "CURITIBA", "cep": "80620010", "logradouro": "AV REPUBLICA ARGENTINA", "uf": null}, "id": 747, "telefone": "4130196138", "email": null, "cnpj_cpf": "21202303000167", "status_nomeado": "OUTRO_NOMEADO", "ativo": true, "nome": "Guizion Labs Ltda", "tipo_pessoa": "JURIDICA"}]
    let response;
    response = await axios.get(
      config.apiUrl + config.versoes[0] + '/tomador/?documento=' + payload.cnpj,
      { timeout: 600000 }
    );

    return response.data;
  },

  async POST_LIMPAR_DOCUMENTOS({ commit }, payload) {
    let response;
    response = await axios.post(
      config.apiUrl + config.versoes[0] + '/tomador/' + payload.id + '/limpar-documentos',
      { timeout: 600000 }
    );

    return response.data;
  },

  async CRIAR_DOCUMENTOS_TOMADOR({ commit }, payload) {
    let response;
    response = await axios.post(
      config.apiUrl + config.versoes[0] + '/tomador/' + payload.id + '/criar-documentos',
      { timeout: 600000 }
    );

    return response.data;
  },



  async GET_TAKER_LIMITES({ commit }, payload) {
    let response;
    response = await axios.get(
      config.apiUrl + config.versoes[0] + '/tomador/' + payload.id + '/limites',
      { timeout: 600000 }
    );
    return response.data;
  },

  async GET_GRUPO_ACUMULO({ commit }, payload) {
    let response;
    response = await axios.get(
      config.apiUrl + config.versoes[0] + '/tomador/' + payload.id + '/grupo-economico-acumulo',
      { timeout: 600000 }
    );
    return response.data;
  },

  async GET_TAKER_LIMITES_MODALIDADES({ commit }, payload) {
    let response;
    response = await axios.get(
      config.apiUrl +
      config.versoes[0] +
      '/tomador/' +
      payload.id +
      '/modalidades',
      { timeout: 600000 }
    );

    return response.data;
  },

  async GET_TAKER_DATA_RAZAOSOCIAL({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl +
      config.versoes[0] +
      '/tomador/?nome=' +
      payload.name +
      '&tipo_pessoa=' +
      payload.personType
    );

    if (!response.data.length) {
      return Promise.reject({ response });
    }
    if (!response.data[0].ativo) {
      return Promise.reject(response.data);
    }
    return response.data;
  },

  async INSERT_CONSORCIO({ commit }, payload) {
    let response = await axios.post(
      config.apiUrl + config.versoes[0] + '/tomador/composicao-consorcio',
      payload
    );
    return response.data;
  },

  async UPLOAD_CARTA_NOMEACAO({ commit }, payload) {
    let response = await axios.post(
      config.apiUrl + config.versoes[0] + '/carta-nomeacao',
      payload
    );
    return response.data;
  },

  async POST_TOMADOR_DOCUMENTOS({ commit }, payload) {
    let idTomador = payload.idTomador;
    delete payload.idTomador;

    let response = await axios.post(
      config.apiUrl +
      config.versoes[0] +
      `/tomador-corretor/${idTomador}/pendencias`,
      payload
    );
    return response.data;
  },

  async POST_TOMADOR_QUESTIONAMENTO({ commit }, payload) {
    let idTomador = payload.idTomador;
    delete payload.idTomador;

    let response = await axios.post(
      config.apiUrl +
      config.versoes[0] +
      `/tomador-corretor/${idTomador}/questionamento`,
      payload
    );
    return response.data;
  },

  async POST_PRE_ANALISE_CREDITO({ commit }, payload) {
    let response = await axios.put(
      config.apiUrl +
      config.versoes[0] +
      `/tomador-credito/${payload.model.documento}/`,
      payload.model
    );

    return response.data;
  },

  async GET_PARAMETERS_TOMADOR({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl + config.versoes[0] + `/parametros/tomador`
    );
    return response.data;
  },

  async GET_TAKER_APOLICES({ commit }, payload) {
    let propostas;
    let page;
    await axios({
      method: 'post',
      url: config.apiUrl + config.versoes[0] + `/propostaTomador/${payload.cnpj}`,
      data: {
        "pagina": payload.pagina_atual ? payload.pagina_atual : 1,
        "itens_por_pagina": payload.total_pagina ? payload.total_pagina : 10,
        "segurado": payload.segurado ? payload.segurado : null,
        "vigencia_inicio": payload.vigencia_inicio ? payload.vigencia_inicio : null,
        "vigencia_fim": payload.vigencia_fim ? payload.vigencia_fim : null,
        "emissao_inicio": payload.emissao_inicio ? payload.emissao_inicio : null,
        "emissao_fim": payload.emissao_fim ? payload.emissao_fim : null,
        "modalidade": payload.modalidade ? payload.modalidade : null,
        "grupo_modalidade": payload.grupo_modalidade ? payload.grupo_modalidade : null,
        "vigente": payload.vigente ? payload.vigente : true
      }
    }).then(res => {
      var { pagina, itens_por_pagina, total_pagina } = res.data;
      page = { pg: pagina, itens_pg: itens_por_pagina, total_pg: total_pagina };
      propostas = res.data.propostas
    });

    return { page, apolices: propostas };
  },

  async GET_FILTERS_APOLICES({ commit }, payload) {
    let response = await axios.get(
      config.apiUrl + config.versoes[0] + `/propostaTomador/${payload.cnpj}/filtros`
    );

    return response.data;
  }
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/taker.js